import { useBooleanFlagValue } from './useBooleanFlagValue'

export const GENERATION_COST_ESTIMATES_VISIBLE_FLAG = 'generation_cost_estimates_visible'
export const MANUAL_GENERATION_COST_ESTIMATES_VISIBLE_FLAG =
  'manual_generation_cost_estimates_visible'

export function useGenerationCostEstimatesVisible(): boolean {
  return useBooleanFlagValue(GENERATION_COST_ESTIMATES_VISIBLE_FLAG, false)
}

export function useManualGenerationCostEstimatesVisible(): boolean {
  return useBooleanFlagValue(MANUAL_GENERATION_COST_ESTIMATES_VISIBLE_FLAG, false)
}
